export default __webpack_public_path__ + "static/media/pc-bg.502e2867.webp";